<script setup lang="ts">
    import LocaleSwitch from "@/components/tellscale/utilities/LocaleSwitch.vue";
    import ColorModeSwitch from "@/components/tellscale/utilities/ColorModeSwitch.vue";
</script>

<template>
    <div class="flex items-center gap-3 flex-wrap">
        <LocaleSwitch/>
        <ColorModeSwitch/>
    </div>
</template>

<style scoped lang="scss">

</style>